const getSocialFromUrl = (url: string) => {
  if (url.includes('instagram')) return 'instagram';
  if (url.includes('facebook')) return 'facebook';
  if (url.includes('tiktok')) return 'tiktok';
  if (url.includes('youtube')) return 'youtube';
  if (url.includes('twitter')) return 'twitter';
  if (url.includes('x.com')) return 'x';
};

const socialLink = (type: string, handle?: string | null) => {
  if (!handle) return '';

  switch (type.toLowerCase()) {
    case 'instagram':
      return `https://www.instagram.com/${handle}`;
    case 'facebook':
      return `https://www.facebook.com/${handle}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${handle}`;
    case 'youtube':
      return `https://www.youtube.com/${handle}`;
    case 'twitter':
    case 'x':
      return `https://x.com/${handle}`;
    default:
      return '';
  }
};

export { getSocialFromUrl, socialLink };
